<RbAuthHeader>
  <div slot="additionalControls">
    <slot />
  </div>

  <div slot="mainControls">

    {#if bookingAnalyticsHref}
      <a href="{bookingAnalyticsHref}"
         class="aBtn asLarge CustomButton Gold"
         data-icon="list_alt"
         class:Active={stateName === BOOKING_ANALYTICS}
      >
        Analytics
      </a>
    {/if}

    {#if showBidManager}
      <a href="{bidManagerHref}"
         class="aBtn asLarge CustomButton"
         data-icon="list_alt"
         class:Active={stateName === BID_MANAGER}
      >
        Bid Manager
      </a>
    {/if}


    {#if isBuyer}
      <a href="{rfpManagerHref}"
         class="aBtn asLarge CustomButton"
         class:Active={stateName === PAGE_RFP_MANAGER}
         data-icon="all_inbox"
      >
        RFP Manager
      </a>
    {/if}

    <a href="http://readybidnet.freshdesk.com" target="_blank"
       class="aBtn asLarge CustomButton" data-icon="help">Need Help?</a>
  </div>
</RbAuthHeader>


<script>
  import { $state as stateProvider, currentUser as currentUserProvider } from 'root/angular-injector-provider';
  import { onMount, onDestroy } from 'svelte';
  import RbAuthHeader from './RbAuthHeader.svelte';
  import {BOOKING_ANALYTICS, BID_MANAGER, PAGE_RFP_MANAGER} from 'root/states';
  import bidManagerStore from 'rfp/bid-manager/main/stores/bid-manager';
  export let showBidManager = true;
  import {BOOKING_ANALYTICS as FEATURE_BOOKING_ANALYTICS} from 'root/auth/account-features';

  const
    rfpManagerHref = stateProvider().href(PAGE_RFP_MANAGER),
    bidManagerHref = stateProvider().href(BID_MANAGER, {viewId: null});

  let
    user = null,
    isBuyer = false,
    bookingAnalyticsHref = undefined,
    stateName = undefined,
    unwatchUser;

  $: stateName = stateProvider().current.name;
  $: isBuyer = !!(user && user.isBuyer('HOTEL_RFP'));
  $: bookingAnalyticsHref = isBuyer && hasFeatureAccess(user) && createBookingAnalyticsHref($bidManagerStore);

  onMount(() => { unwatchUser = currentUserProvider().watch(u => user = u) });
  onDestroy(() => { if(unwatchUser) unwatchUser() });

  function hasFeatureAccess(u) {
    return u && u.hasFeature(FEATURE_BOOKING_ANALYTICS);
  }

  function createBookingAnalyticsHref(bms){
    const state = stateProvider();
    if(state.is(BOOKING_ANALYTICS)){
      return window.location.href;
    } else if(!bms || bms.side !== 'BUYER' || !bms.rfpId || !bms.buyerCompanyAccountId) {
      return undefined;
    } else {
      return state.href(BOOKING_ANALYTICS, {accountId: bms.buyerCompanyAccountId, rfpId: bms.rfpId});
    }
  }

</script>


<style lang="stylus">
  @import '../header.blocks.styl';

  .aBtn.asLarge.CustomButton {
    {CustomButton}
    box-sizing: border-box;

    &.Gold {
      background: #D1B000 linear-gradient(0deg, rgba(255, 215, 0, 0.6) 10%, #D1B000 100%);
      border: 2px solid #FFD700;
      color: white;
      text-shadow:0 0 1px #D1B000;
      border-radius: 2px;

      &:hover {
        background: #D1B000;
        text-shadow:0 0 1px white;
      }
    }

    &.Active {
      {CustomButtonActive}

        &.Gold {
          border: 2px solid #FFD700;
          background: #D1B000;
          text-shadow:0 0 1px white;
        }
    }
  }
</style>
